<template>
  <el-dialog
      :title="'Thêm ca cho : ' + teamName"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="5vh"
  >
    <el-table
        ref="multipleTable"
        highlight-current-row
        :empty-text="textTable"
        :data="responseList"
        :cell-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
        :max-height="$tableMaxHeight"
        border
    >
      <el-table-column
          type="index"
          label="STT"
          width="50"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="name"
          label="Tên ca"
          min-width="190"
      ></el-table-column>
      <el-table-column
          prop="description"
          label="Mô tả"
          min-width="180"
      ></el-table-column>
      <el-table-column
          prop="startTime"
          align="center"
          label="Thời gian bắt đầu"
          min-width="150"
      ></el-table-column>
      <el-table-column
          prop="endTime"
          align="center"
          label="Thời gian kết thúc"
          min-width="150"
      ></el-table-column>
      <el-table-column
          prop="autoAttendanceEnable"
          align="center"
          label="Đối tượng áp dụng"
          width="100"
      >
        <template v-slot:default="scope">
          <span v-if="scope.row.targetType === 'STUDENT'">Học sinh</span>
          <span v-if="scope.row.targetType === 'TEACHER'">Nhân viên</span>
          <span v-if="scope.row.targetType === 'GROUP'">Nhóm</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="autoAttendanceEnable"
          align="center"
          label="Điểm danh tự động AI"
          width="100"
      >
        <template v-slot:default="scope">
          <span v-if="scope.row.autoAttendanceEnable">Có</span>
          <span v-else>Không</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" align="center">
        <template slot="header" slot-scope="scope">
          <div>Áp dụng</div>
          <el-checkbox
              @change="checkUseAllMethod(scope.$index)"
              v-model="checkAll"
          ></el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.assigned"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex">
      <el-col :span="22" style=" margin: 15px 0">
        <div class="container_nav_page">
          <el-pagination
              background
              layout="prev, pager, next, sizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentPageChange"
              :current-page.sync="dataSearch.page"
              :page-sizes="listSizePage"
              :total="total">
          </el-pagination>
        </div>
      </el-col>
      <el-col :span="4">
        <div style="float: right; margin: 15px 0">
          <span slot="footer" class="dialog-footer">
            <el-button type="danger" size="medium" @click="closeDialog()">
              <i class="el-icon-circle-close"/>
              <span>Đóng</span>
            </el-button>
            <el-button
                type="success"
                size="medium"
                :loading="loadingButton"
                mini
                @click="submitForm()"
            >
              <i class="el-icon-circle-check"/>
              <span>Lưu</span>
            </el-button>
          </span>
        </div>
      </el-col>
    </el-row>

  </el-dialog>
</template>

<script>
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import shiftMaster from "@/services/ShiftMaster";

export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      textTable: this.$tableLoading,
      teamId: "",
      teamName: "",
      responseList: [],
      responseList1: [],
      loadingButton: false,
      checkAll: false,
      type: "",
      total: 0,
      dataSearch: {
        limit: 25,
        page: 1,
      },
      listSizePage: [25, 50, 100, 150, 200],
    };
  },
  methods: {
    name: "AddShiftManagementDialog",
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyle({row}) {
      if (row.category === "out") {
        return "color: #409EFF";
      }
    },
    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.searchPackageProperties();
    },
    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.searchPackageProperties();
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.responseList = [];
        this.checkAll = false;
      }, 300);
    },
    checkUseAllMethod() {
      this.responseList.forEach((x) => {
        x.assigned = this.checkAll;
      });
    },
    submitForm() {
      let dataList = this.responseList.filter((x) => x.assigned);
      let shiftIds = [];
      dataList.forEach((x) => {
        shiftIds.push(x.id);
      });

      this.loadingButton = true;
      let dataInput = {
        teamId: this.teamId,
        teamType: this.type,
        shiftIds: shiftIds,
      };
      shiftMaster.createTeamShiftAssignments(dataInput)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Thêm ca thành công!")
            this.loadingButton = false;
            setTimeout(() => {
              this.closeDialog();
            }, 500);
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Thêm ca thất bại!");
          });


    },
    getAddDataInitial(row, type) {
      this.teamId = row.id;
      this.teamName = row.teamName;
      this.type = type
      shiftMaster.getAllShiftsForTeam(row.id, this.type, this.dataSearch.page, this.dataSearch.limit)
          .then((resp) => {
            this.responseList = resp.data.data.content;
            this.total = resp.data.data.totalElements;
            if (this.responseList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
          })
          .catch((err) => {
            console.log(err);
          });

    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
